// Feature flags for the messaging client.
//
// groupMessagingEnabled(rally): whether a user may start / grow a group
// (3+ person) thread. Resolution order:
//   1. Server: a `group-messaging-enabled` attribute on the rally payload
//      (rrs can expose this per rally or from an env flag; absent today).
//   2. Client kill switch: window.RH_FEATURES.groupMessaging — settable at
//      runtime in the console or by any script that runs before the app.
//   3. Default: OFF. With the flag off the UI is a 1:1 messenger — no
//      banner, no multi-recipient picker, no add-member / rename on threads.
// Existing group threads remain readable either way; only creation and
// growth are gated. rchans is the authority for creation; this is the UI.
export function groupMessagingEnabled(rally = null) {
  const attrs = rally?.rally?.attributes || rally?.attributes || null;
  if (attrs && attrs["group-messaging-enabled"] != null) {
    return attrs["group-messaging-enabled"] === true || attrs["group-messaging-enabled"] === "true";
  }
  if (typeof window !== "undefined" && window.RH_FEATURES && window.RH_FEATURES.groupMessaging != null) {
    return !!window.RH_FEATURES.groupMessaging;
  }
  return true;
}
